const SESSION_KEY = 'popin_dismissed';

function openPopin($popin) {
  if (!$popin.open) {
    $popin._triggerElement = document.activeElement;
    $popin.showModal();
  }
}

function waitForTACThenShow($popin) {
  const tacBanner = document.getElementById('tarteaucitronAlertBig');

  if (tacBanner) {
    if (tacBanner.style.display === 'block') {
      const observer = new MutationObserver(() => {
        if (tacBanner.style.display !== 'block') {
          observer.disconnect();
          openPopin($popin);
        }
      });
      observer.observe(tacBanner, { attributes: true, attributeFilter: ['style'] });
    } else {
      openPopin($popin);
    }
    return;
  }

  // TAC pas encore injecté dans le DOM : on observe son apparition
  const domObserver = new MutationObserver((_, obs) => {
    const banner = document.getElementById('tarteaucitronAlertBig');
    if (!banner) return;
    obs.disconnect();
    clearTimeout(fallback);

    // On observe immédiatement les changements de style (TAC peut mettre display:block juste après l'insertion)
    const styleObserver = new MutationObserver(() => {
      if (banner.style.display !== 'block') {
        styleObserver.disconnect();
        openPopin($popin);
      }
    });
    styleObserver.observe(banner, { attributes: true, attributeFilter: ['style'] });

    // Court délai pour laisser TAC poser son display:block éventuel avant de décider
    setTimeout(() => {
      if (banner.style.display !== 'block') {
        styleObserver.disconnect();
        openPopin($popin);
      }
    }, 500);
  });
  domObserver.observe(document.body, { childList: true, subtree: true });

  // Fallback : si TAC n'apparaît pas du tout (consentement déjà enregistré, plugin désactivé…)
  const fallback = setTimeout(() => {
    domObserver.disconnect();
    openPopin($popin);
  }, 3000);
}

document.addEventListener('DOMContentLoaded', () => {
  const $popin = document.querySelector('.c-popin');
  if (!$popin || sessionStorage.getItem(SESSION_KEY)) {
    return;
  }

  $popin.addEventListener('close', () => {
    $popin._triggerElement?.focus();
  });

  $popin.querySelector('.c-popin__close')?.addEventListener('click', () => {
    $popin.close();
    sessionStorage.setItem(SESSION_KEY, '1');
  });

  $popin.addEventListener('click', (e) => {
    if (e.target === $popin) {
      $popin.close();
      sessionStorage.setItem(SESSION_KEY, '1');
    }
  });

  $popin.querySelectorAll('.c-popin__actions a').forEach(($link) => {
    $link.addEventListener('click', () => {
      sessionStorage.setItem(SESSION_KEY, '1');
    });
  });

  waitForTACThenShow($popin);
});
